import styled from 'styled-components';

export const ForwardContainer = styled.div`
  border-left: 3px solid #28a745;
  background: #f8fff9;
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 6px;
  font-size: 13px;
  color: #4a4a4a;
  border: 1px solid #e3f2e6;
`;

export const ForwardHeader = styled.div`
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 0.85rem;
  color: #28a745;
  display: flex;
  align-items: center;
`;

export const ForwardMeta = styled.div`
  font-size: 0.75rem;
  color: #6c757d;
  margin-bottom: 8px;
  font-weight: 500;
`;

export const ForwardContent = styled.div`
  font-size: 0.85rem;
  color: #333;
  max-height: 5em;
  overflow: hidden;
  position: relative;
  transition: max-height 0.3s ease;

  &.expanded {
    max-height: 35rem;
  }
`;

export const ToggleExpand = styled.div`
  font-size: 0.75rem;
  color: #28a745;
  cursor: pointer;
  margin-top: 8px;
  user-select: none;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }
`;

export const RecipientsList = styled.div`
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const RecipientItem = styled.span`
  background: #e7f3ff;
  color: #0066cc;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 0.7rem;
  border: 1px solid #b3d9ff;
`;

export const ViewersList = styled.div`
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const ViewerItem = styled.span`
  background: #fff3cd;
  color: #856404;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 0.7rem;
  border: 1px solid #ffeaa7;
`;

export const HistoryToggle = styled.div`
  font-size: 0.75rem;
  margin: 6px 0;
  padding: 4px 8px;
  border-radius: 4px;

  &.enabled {
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }

  &.disabled {
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }
`;

export const ForwardedItemsList = styled.div`
  margin-top: 4px;
  display: flex;
  flex-flow: column nowrap;
  flex-wrap: wrap;
  gap: 4px;
`;

export const ForwardedItem = styled.div`
  background: #f8f9fa;
  color: #495057;
  border-radius: 4px;
  padding: 12px 16px;
  font-size: 0.8rem;
  border: 1px solid #dee2e6;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  margin-left: ${(props) => `${props.mf}rem`};

  p {
    margin: 0;
    line-height: 1.4;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    height: 1.2em;
    width: 30px;
    background: linear-gradient(to right, transparent, #f8f9fa);
  }

  &:hover:after {
    background: linear-gradient(to right, transparent, #e9ecef);
  }
`;
